import PauseIcon from '@mui/icons-material/Pause';
import PlayIcon from '@mui/icons-material/PlayArrow';
import { Button, IconButton, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { useAuditMatchPlaybackControl } from '../../hooks/useAuditMatchPlaybackControl';
import { AuditMatch } from '../../types';

export function PlayButtonP(p: { play: () => void }) {
  const { $t } = useIntl();
  return (
    <Button size="small" sx={{ marginTop: 0.5 }} onClick={p.play}>
      {$t({
        id: 'common.play',
        defaultMessage: 'Reproducir',
      })}
    </Button>
  );
}

export function PlayButton(p: { match: AuditMatch }) {
  const { $t } = useIntl();
  const { showPause, handleClick } = useAuditMatchPlaybackControl(p.match);

  return (
    <Tooltip
      title={
        showPause
          ? $t({
              id: 'common.pause',
              defaultMessage: 'Pausar',
            })
          : $t({
              id: 'common.play',
              defaultMessage: 'Reproducir',
            })
      }
    >
      <IconButton size="small" color="primary" onClick={handleClick}>
        {showPause ? <PauseIcon /> : <PlayIcon />}
      </IconButton>
    </Tooltip>
  );
}
